import { useEffect, useState, useRef } from "react";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, getDownloadURL } from "firebase/storage";

function MapaEditor({ mapa }) {
  const [pins, setPins] = useState([]);
  const [imagemUrl, setImagemUrl] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  const imagemRef = useRef(null);

  useEffect(() => {
    if (!mapa.mapa) return;

    const carregarImagem = async () => {
      try {
        const url = await getDownloadURL(ref(storage, mapa.mapa));
        setImagemUrl(url);
      } catch (err) {
        console.error("Erro ao carregar imagem:", err);
      }
    };

    carregarImagem();
  }, [mapa.mapa]);

  useEffect(() => {
    const fetchPins = async () => {
      const snap = await getDocs(collection(db, `evento_mapas/${mapa.id}/pins`));
      setPins(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    fetchPins();
  }, [mapa.id]);

  const adicionarPin = async () => {
    const novo = { titulo: "Novo Pin", x: 0.5, y: 0.5 };
    const docRef = await addDoc(collection(db, `evento_mapas/${mapa.id}/pins`), novo);
    setPins(prev => [...prev, { id: docRef.id, ...novo }]);
  };

  const atualizarPos = async (id, x, y) => {
    const nx = Math.min(0.99, Math.max(0.01, x));
    const ny = Math.min(0.99, Math.max(0.01, y));
    await updateDoc(doc(db, `evento_mapas/${mapa.id}/pins/${id}`), { x: nx, y: ny });
    setPins(prev => prev.map(p => (p.id === id ? { ...p, x: nx, y: ny } : p)));
  };

  const atualizarTitulo = async (id, titulo) => {
    await updateDoc(doc(db, `evento_mapas/${mapa.id}/pins/${id}`), { titulo });
  };

  const removerPin = async (id) => {
    await deleteDoc(doc(db, `evento_mapas/${mapa.id}/pins/${id}`));
    setPins(prev => prev.filter(p => p.id !== id));
  };

  const handleClickMapa = async (e) => {
    if (!imagemRef.current) return;
    const rect = imagemRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    const novo = { titulo: "Novo Pin", x, y };
    const docRef = await addDoc(collection(db, `evento_mapas/${mapa.id}/pins`), novo);
    setPins(prev => [...prev, { id: docRef.id, ...novo }]);
  };

  if (!imagemUrl) return <p>A carregar mapa...</p>;

  return (
    <div>
      <button className="btn btn-add" onClick={adicionarPin}> Novo Pin </button>
      <div
        style={{
          position: "relative",
          display: "inline-block",
          border: "1px solid #ccc",
          marginTop: 10,
          width: "100%",
          maxWidth: 800,
          height: 500,
          overflow: "hidden",
        }}
        onClick={handleClickMapa}
      >
        <img
          ref={imagemRef}
          src={imagemUrl}
          alt="Mapa"
          onLoad={() => setImgLoaded(true)}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            userSelect: "none",
            objectFit: "contain",
            backgroundColor: "#f0f0f0",
          }}
        />

        {imgLoaded && pins.map(pin => (
          <div
            key={pin.id}
            draggable
            onClick={(e) => e.stopPropagation()}
            onDragEnd={(e) => {
              const rect = imagemRef.current.getBoundingClientRect();
              const x = (e.clientX - rect.left) / rect.width;
              const y = (e.clientY - rect.top) / rect.height;
              atualizarPos(pin.id, x, y);
            }}
            style={{
              position: "absolute",
              left: `${pin.x * imagemRef.current.offsetWidth}px`,
              top: `${pin.y * imagemRef.current.offsetHeight}px`,
              transform: "translate(-50%, -100%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 22,
              cursor: "grab",
            }}
          >
            <input
              type="text"
              value={pin.titulo}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) =>
                setPins(prev => prev.map(p => (p.id === pin.id ? { ...p, titulo: e.target.value } : p)))
              }
              onBlur={(e) => atualizarTitulo(pin.id, e.target.value)}
              style={{
                fontSize: 14,
                textAlign: "center",
                marginBottom: 2,
                width: 80,
              }}
            />
            📍
            <button
              onClick={(e) => { e.stopPropagation(); removerPin(pin.id); }}
              style={{
                marginLeft: 4,
                background: "transparent",
                border: "none",
                color: "red",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MapaEditor;
